class BackToTop {
  constructor(){
 //   document.body.insertAdjacentHTML( "beforeend", '<a id="back-to-top" title="Back to top" href="#"><i class="bi bi-chevron-double-up"></i></a>');

    this.backToTop = document.querySelector('.back-to-top')
    if (this.backToTop) {      
      this.events()      
    }
  }

  events(){
    this.backToTop.style.opacity = '0'
    this.backToTop.style.cursor = 'default'
  
    
    window.addEventListener('scroll', ()=>{
      const WindowScrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
      if ( WindowScrollTop  > 100) {     
        this.backToTop.style.opacity = "1";  
        this.backToTop.style.cursor = 'pointer'  
         
      } 
      else {     
        this.backToTop.style.opacity = "0";  
        this.backToTop.style.cursor = 'default'      
        
      } 
    })

    this.backToTop.addEventListener('click', function(e){
      e.preventDefault(); 
      //window.scrollTo(0, 0);
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // 👈 this makes it gently scroll up
      });
    })
  }

}

//export default BackToTop
const newBackToTop = new BackToTop()